import React, { ReactNode } from "react";
import { Box } from "@mui/material";
import MSpinner from "./MSpinner";

interface Props {
  loadingMessages: ReactNode[],
};

/** @description Shows a Loading Cover over all of the elements that are in the same parent. Parent element must have position: relative */
const LoadingCover = ({ loadingMessages }: Props) => {
  return (
    <Box sx={{
      width: '100%',
      height: '100%',
      position: 'absolute',
      backgroundColor: 'var(--translucent-white)',
      zIndex: 10,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      top: 0,
      left: 0,
    }}>
      <Box sx={{
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'var(--tertiary-color)',
        '& .mspinner': {
          marginBottom: '35px',
        },
      }}>
        <MSpinner />
        {loadingMessages.map((m, i) => <div key={i}>{m}</div>)}
      </Box>
    </Box>
  );
};

export default LoadingCover;
